export default __webpack_public_path__ + "static/media/manawb.a89bb643.svg";